import { render, staticRenderFns } from "./RegionSwitcher.vue?vue&type=template&id=291453f0&scoped=true&"
import script from "./RegionSwitcher.vue?vue&type=script&lang=js&"
export * from "./RegionSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./RegionSwitcher.vue?vue&type=style&index=0&id=291453f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291453f0",
  null
  
)

export default component.exports